import { ThemeConfiguration, ThemeProperty } from 'mm-theme-configuration';

export const CONFIGURATION_TYPES = {
  COLOR: 'COLOR',
  TYPOGRAPHY: 'TYPOGRAPHY',
  SURFACE: 'SURFACE',
  VR_LINEHEIGHT: 'VERTYCAL_RHYTHM',
};

type Instructions = { [key: string]:(key: string) => string | object};

function translatePropertyValueByType(instructions:Instructions, { value, type }: ThemeProperty) {
  if (typeof instructions === 'undefined') {
    throw new Error('must supply instructions to the transformation');
  }
  if (typeof instructions[type] !== 'function') {
    throw new Error(`there is no instruction function to type: ${type}`);
  }
  return instructions[type](value);
}

function translateProperty(instructions: Instructions, property:ThemeProperty) {
  return {
    [property.name]: translatePropertyValueByType(instructions, property),
  };
}

function translateComponent(instructions: Instructions, themeProperties:ThemeProperty[]) {
  return themeProperties.reduce((accumulator, componentProperty) => ({
    ...accumulator,
    ...translateProperty(instructions, componentProperty),
  }), {});
}

export function translate(instructions: Instructions, configuration: ThemeConfiguration): {[key: string]: any} {
  return Object.keys(configuration).reduce((accumulator, name) => (
    {
      ...accumulator,
      [name]: translateComponent(instructions, configuration[name]),
    }), {});
}
